<!-- left nav changes container -->
<!-- class and css changes -->
<div class="flex-body">
  <span class="page-header-left flex-inline-body">
    <a class="page-icon" style="cursor: pointer;" (click)="cancel()"><i class="{{icon}}"></i></a>
    <span class="page-title align-center">{{title}}</span>
  </span>
  <span class="page-header-right"></span>
</div>
<!-- end -->

<p-dialog [(visible)]="confirmAddAf" [modal]="true"  [style]="{ minWidth: '350px' }" [minY]="70">
  <p-header>
      {{'vbeiConfirmationRequested' | translate}}
  </p-header>
  <div class="m-b-12">{{'vbeiDiscardChanges' | translate}}
      <br>
  </div>
  <p-footer>
      <div class="text-right">
          <button pButton type="button" label="{{'vbeiYes' | translate}}" class="p-button-tertiary" (click)="confirmYes()"></button>
          <button pButton type="button" label="{{'vbeiNo' | translate}}" class="p-button-tertiary" (click)="confirmNo()"></button>
      </div>
  </p-footer>
</p-dialog>
